import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'

const sectionEndpoint = 'news/'

export const generateAudioForNews = createAsyncThunk(
  'news/generateAudio',
  async (props: { id: EntityId; voice?: string }) => {
    try {
      const response = await api.get(
        `${sectionEndpoint}${props.id}/generate/` +
          (props.voice ? `?voice=${props.voice}` : '')
      )
      return response.data.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Error: ${serverError.message || 'Nepodrařilo se vygenerovat audio'}`
        )
      } else {
        toast.error('Nepodrařilo se vygenerovat audio')
      }
      throw axiosError
    }
  }
)

export const lockNews = createAsyncThunk(
  'news/lockNews',
  async (newsId: EntityId) => {
    try {
      const response = await api.get(`${sectionEndpoint}${newsId}/lock/`)
      return response.data.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(`${serverError.message || 'Nepodařilo se zamknout zprávu'}`)
      } else {
        toast.error('Nepodařilo se zamknout zprávu')
      }
      throw axiosError
    }
  }
)

export const unlockNews = createAsyncThunk(
  'news/unlockNews',
  async (newsId: EntityId) => {
    try {
      const response = await api.get(`${sectionEndpoint}${newsId}/unlock/`)
      return response.data.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se odemknout zprávu'}`
        )
      } else {
        toast.error('Nepodařilo se odemknout zprávu')
      }
      throw axiosError
    }
  }
)
